(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('LenderIntegrationBlacklistDialogController', LenderIntegrationBlacklistDialogController);

    LenderIntegrationBlacklistDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'LenderIntegrationBlacklist', 'Lender', 'Integration'];

    function LenderIntegrationBlacklistDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, LenderIntegrationBlacklist, Lender, Integration) {
        var vm = this;

        vm.lenderIntegrationBlacklist = entity;
        vm.clear = clear;
        vm.save = save;
        vm.lenders = Lender.query({size:2000});
        console.log(vm.lenders);
        vm.integrations = Integration.query({size:2000});
        console.log(vm.integrations);


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            console.log(vm.lenderIntegrationBlacklist);
            if (vm.lenderIntegrationBlacklist.id !== null) {
                LenderIntegrationBlacklist.update(vm.lenderIntegrationBlacklist, onSaveSuccess, onSaveError);
            } else {
                LenderIntegrationBlacklist.save(vm.lenderIntegrationBlacklist, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('valueconnectApp:lenderIntegrationBlacklistUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
